import {Directive, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {UserRuleReader} from '@ui-app/services/user-rules-reader.service';

@Directive({
    selector: '[isUSI]'
})
export class IsUSIDirective implements OnInit {

    constructor(
        private viewContainerRef: ViewContainerRef,
        private template: TemplateRef<any>,
        private userRuleReader: UserRuleReader
    ) {
    }

    ngOnInit(): void {
        if (this.userRuleReader.isUSIUser) {
            this.viewContainerRef.createEmbeddedView(this.template);
        }

    }

}
